module.exports = __webpack_public_path__ + "img/Brushes-min.a974f0e1.png";